<template>
    <v-card min-width="20vw" align="center" justify="center" outlined>
        <v-card-title >
            <v-list-item>
                <v-list-item-title><h2>{{ $t('title_DeleteBrokerAccount') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 py-7">
            <p>{{ $t('firstMessage') }} <b>{{ brokerAccount.type }}</b> {{ $t('secondMessage') }} <b>{{ brokerAccount.broker.name }}</b>?</p>
            <v-btn @click="deleteBrokerAccount">{{ $t('btnDelete') }}</v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapMutations } from 'vuex';
    import Repository from '../../../repositories/brokerAccount';
    export default {
        name: "DeleteBrokerAccount",
        props: {
            brokerAccount: Object,
        },
        methods: {
            ...mapMutations(['setBrokerAccounts']),
            async deleteBrokerAccount() {
                await Repository.deleteBrokerAccount(this.brokerAccount.id).then((response) => {
                    if(response.status < 450) {
                        if(response.data) {
                            alert(this.$t('removedAlert'));
                            Repository.allBrokerAccountsOfUser().then((response) => {
                                this.setBrokerAccounts(response.data);
                            });
                        }
                        else
                            alert(this.$t('cantRemovedAlert'));
                    }
                }).catch((error)=>{
                    // eslint-disable-next-line no-console
                    console.log(`S: ${error.response.status}, M: ${error.response.message}`);
                });
                this.$emit('closeWindow');
            },
            closeWindow() {
                this.$emit('closeWindow');
            }
        }
    }
</script>



<style scoped>

</style>
